<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      {{ rTitle }}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('REPORTS.VIEW_REPORT.SEARCH_TEXT')"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        small
        class="mr-2 ma-3"
        color="success"
        @click="exportReport()"
      >{{ $t('REPORTS.BTNS.EXPORT') }}</v-btn> 
      <v-btn
        small
        class="mr-2 ma-3"
        color="secondary"
        @click="closeReport()"
      >{{ $t('REPORTS.BTNS.CLOSE') }}</v-btn> 
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="reportSqlData"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="ID"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
      fixed-header
    >
    </v-data-table>

    
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'viewreport',
    computed: {
      ...mapGetters(['rTitle', 'rSql', 'reportSqlData'])
    },
    data: function() {
      return {
        loading: false,
        search: '',
        headers: [],
        sortBy: '',
        sortDesc: false
      }
    },
    created() {
      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'REPORT_SQL_DATA') {
          this.loading = false;
          this.setHeaders();
        }

      });

      this.loading = true;
      let payload = {
        'reportSql': this.rSql
      };

      this.$store.dispatch('runReport', payload);
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      setHeaders() {
        this.headers = [];
        if(this.reportSqlData.length > 0) {
          let headerKeys = Object.keys(this.reportSqlData[0]);
          let colWidth = 0;

          headerKeys.forEach((key, index) => {
            colWidth = key.length * 10;
            if(index == 0) {
              this.headers.push({ text: key, value: key, align: 'start', sortable: true, width: colWidth });
            }else {
              this.headers.push({ text: key, value: key, sortable: true, width: colWidth });
            }
          });
        }
      },
      closeReport() {
        this.$router.push({ name: 'Reports' });
      },
      exportReport() {
        let heading = Object.keys(this.reportSqlData[0]).join(',') + '\n';
        let body = this.reportSqlData.map((j) => Object.values(j).join(',')).join('\n');
        let csv = `${heading}${body}`;
        this.downloadCsv(csv);
      },
      downloadCsv(csvData) {
        // Create CSV file object and feed our
        // csv_data into it
        let CSVFile = new Blob([csvData], { type: 'text/csv' });
    
        // Create to temporary link to initiate
        // download process
        var temp_link = document.createElement('a');
    
        // Download csv file
        temp_link.download = this.rTitle + '.csv';
        var url = window.URL.createObjectURL(CSVFile);
        temp_link.href = url;
    
        // This link should not be displayed
        temp_link.style.display = "none";
        document.body.appendChild(temp_link);
    
        // Automatically click the link to trigger download
        temp_link.click();
        document.body.removeChild(temp_link);
      }
    }
  }
</script>
<style>
  .rsl-fixed-height {
    max-width: calc(100vw - 275px);
  }
</style>